import React, { useEffect, useState } from 'react'
import areaCast from '../../assets/area_cast.png'
import areaCat from '../../assets/area_cat.png'
import fedefarmaLogo from '../../assets/fedefarma-logo.png'
import Cookies from 'universal-cookie'
import { useNavigate, useSearchParams } from 'react-router-dom'
import LoginForm from '../LoginForm'
import ResetPasswordForm from '../ResetPasswordForm'
import { FARMACLOUD_URL, URL_BASE } from '../../infrastructure/constants/configurations'
import axios from 'axios'
import psl from 'psl'
import CookiesNotEnabledWarning from '../CookiesNotEnabledWarning'

const LoginScreen = () => {
  const cookies = new Cookies()
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()
  const [showResetPasswordForm, setShowResetPasswordForm] = useState(false)
  const [areCookiesEnabled] = useState(navigator.cookieEnabled)
  const [tryingToLogin, setTryingToLogin] = useState(true)
  const [userCode, setUserCode] = useState('')
  // const [cookieSet, setCookieSet] = useState(false)
  const [code] = useState(searchParams.get('code'))
  const [currentCookie, setCurrentCookie] = useState(cookies.get('avoid_sso_1', { path: '/' }))
  const [parsedDomain] = useState(psl.parse(window.location.hostname))

  // const removeCookies = () => {
  //   for (const cookie in cookies.getAll()) {
  //     console.log(cookie)
  //     cookies.remove(cookie)
  //   }
  // }

  /* Checking if the user is logged in or not. If not, it redirects to the login page. */
  /* A workaround to avoid the infinite loop of redirects that happens when the user is not logged in. */
  useEffect(() => {
    const redirect = () => {
      setTimeout(function () {
        location.href = window.location.href
        document.location.href = FARMACLOUD_URL + 'referrer'
      }, 250)
    }

    setTimeout(() => {
      setCurrentCookie('true')
      cookies.remove('avoid_sso_1', { path: '/' })
    }, 500)

    setTimeout(() => {
      setCurrentCookie('true')
      cookies.remove('ap_avoid_sso', { path: '/', domain: parsedDomain.domain })
    }, 750)

    const logout = searchParams.get('logout')

    if (code) {
      axios
        .get(URL_BASE + 'farmacloud/code/' + code)
        .then((response) => {
          console.log({ status: response.status })
          if (response.status === 202) redirect()
        })
        .catch((error) => {
          console.log({ status: error?.response?.status })
          setTimeout(() => {
            window.location.href = location.protocol + '//' + location.host + location.pathname
          }, 5000)
        })
      return
    }
    if (logout) {
      navigate('/')
    }

    if (tryingToLogin === false) return
    if (currentCookie === 'true') {
      return
    }
    cookies.set('avoid_sso_1', true, { path: '/', maxAge: 10 })
    cookies.set('ap_avoid_sso', true, { path: '/', domain: parsedDomain.domain })
    if (!areCookiesEnabled) return
    redirect()
  }, [])

  useEffect(() => {
    setTimeout(() => {
      setTryingToLogin(false)
    }, 1500)
  }, [])

  const [lang] = useState(navigator.language || Navigator.userLanguage)

  if (code || currentCookie !== 'true') {
    return (
      <div className="tw-flex tw-flex-col tw-m-auto tw-w-screen tw-h-screen tw-justify-center tw-items-center">
        <img
          className={'tw-px-2 tw-py-6 tw-self-center'}
          alt='Fedefarma área privada'
          src={fedefarmaLogo}
          width={290}
        />
        <svg aria-hidden="true" className="tw-mr-2 tw-w-12 tw-h-12 tw-text-gray-200 tw-animate-spin dark:tw-text-gray-300 tw-fill-[#B31882]"
             viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
            fill="currentColor"/>
          <path
            d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
            fill="currentFill"/>
        </svg>
      </div>
    )
  }

  return (
    <div className={`login ${tryingToLogin === true ? 'tw-block' : 'tw-block'}`}>
      {
        !areCookiesEnabled && (
          <CookiesNotEnabledWarning lang={lang}/>
        )
      }
      {showResetPasswordForm && <div></div>}
      <header className='App-header'>
        <div
          className={
            'tw-flex tw-w-full tw-h-full tw-px-24 2xl:tw-px-52 tw-justify-center xl:tw-justify-between'
          }
        >
          <div
            className={
              'tw-pt-10 tw-flex tw-h-fullt tw-my-auto tw-flex-col tw-justify-center 2xl:tw-justify-center tw-hidden xl:tw-block tw-items-center'
            }
          >
            <img
              alt='Descubre el nuevo universo cloud'
              src={lang === 'es' ? areaCast : areaCat}
              width={330}
              height={350}
            />
          </div>
          <div
            className={
              'tw-bg-blue-300 tw-self-center tw-flex tw-h-[490px] tw-mr-0'
            }
          >
            <div
              className={
                'tw-flex tw-flex-col tw-w-[400px] tw-h-full tw-border-gray-400 tw-text-black tw-border-2 tw-rounded tw-bg-white tw-p-10'
              }
            >
              <img
                className={'tw-px-2 tw-py-6 tw-self-center'}
                alt='Fedefarma área privada'
                src={fedefarmaLogo}
                width={490}
              />
              {
                !showResetPasswordForm
                  ? <LoginForm userCode={userCode} setUserCode={setUserCode}
                               setShowResetPasswordForm={setShowResetPasswordForm} lang={lang}/>
                  : <ResetPasswordForm userCode={userCode} setUserCode={setUserCode} lang={lang} setShowResetPasswordForm={setShowResetPasswordForm}/>
              }
            </div>

          </div>
        </div>
      </header>
    </div>
  )
}

export default LoginScreen
